import { IconType } from "react-icons";
import { TbFileText, TbLink } from "react-icons/tb";

import { EXTERNAL_URLS } from "@/constants/urls";

type ExternalTool = {
    label: string;
    icon: IconType;
    url: string;
};

export const externalTools: ExternalTool[] = [
    {
        label: "CRM",
        icon: TbLink,
        url: EXTERNAL_URLS.CRM,
    },
    {
        label: "Blueprints",
        icon: TbFileText,
        url: EXTERNAL_URLS.Blueprint,
    },
];
